import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LPService} from "./services/lp.service";
import {ReplaceStringPipe} from "./pipes/replace-string.pipe";


@NgModule({
	declarations: [ReplaceStringPipe],
	imports: [
		CommonModule
	],
	providers: [LPService],
	exports: [ReplaceStringPipe]
})
export class SharedModule {
}
